/*
 * @Author:
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-15 14:15:44
 * @Description:
 */
import { defineStore } from 'pinia';
import { oSettingOfGames } from './game';
import { useJoinStateStore } from '../cansino/joinState';
export type LangOperate = 'switch' | 'ignore';

const useSettingsStore = defineStore('settings', {
    state: () => ({
        ...{
            // 货币金额相关
            pickedCurrency: '', // usdt, btc, ...(当前币种)
            pickedCurrencyTs: 0, // 当前币种设定时间戳（毫秒） 
            fiatCurrency: '', // usd,
        },
        ...{
            // 界面显示相关
            chatIsOpen: false,
            UILang: '', // 用于标记用户是否曾设定过界面语言（对于已经登录的用户，在 UserStore 中记录着此用户的设定语言） 
            langOperation: '' as LangOperate, // switch, ignore
            proModePopupDontShow: false, // 控制是否弹出“Pro Mode模式” 的提示窗口（疑似用不上了，因为窗口不再主动展示，仅在用户点击之后弹出。进入观察期，将来删除） 
        },
        isNotificationsPanelOpen: false,
        hideZeroBalance: false,
        inFiat: false,
        hotKeys: false,
        statisticsLimit: 20,
        promotionsWidget: true,
        animation: true, // 表示是否启用游戏动画
        hideBlockedGames: false,
        demoNotificationCount: 0,
        froms: null,
        activeNotifyTab: 0,
        // 各游戏配置
        game: oSettingOfGames,
        notifications: {
            view: {
                label: 'View all',
                value: 'all',
            },
        },
        contests: {
            isOpenContestsPanel: false,
            type: '',
            contentType: 'active',
            id: '6532977cdea01c745635df4a',
            panelAnimation: false,
        },
        // ↓ 全局音乐设定 🧧 重要：最大音量设为1，与 new Audio 同步
        ...{
            // sound: true, platformSound: true,
            // ↑ 以上两项通过在原站点实测，发现与 globalSounds 同步变化，因此暂时注释，将来删除，于 2024.01.11 14:55:17 星期四
            globalSounds: true, // 【全局】 音乐是否启用标记
            globalVolume: 1, // 【全局】游戏的背景音乐
            globalSoundEffects: 1, // 【全局】游戏的事件音效
            // gameVolume: 0, // 看似是：当前游戏背景音乐
        },
        // 重要说明，保留勿删：
        // 实测得出，顶部全局设定被修改后，相同的值将写入下方 sound 中
        // 若下方值被修改，不会写入上方全局设定中
        inhouseGames: {
            // ↓ 游戏音乐设定 🧧 音量范围 0-1 与 new Audio 同步
            sound: {
                // 当前游戏的音乐设定
                on: true,
                music: 1,
                effects: 1,
            },
            onBoarding: {
                // ↓ 当某游戏名出现在这里，说明已经向用户弹出了 GameIntroduction 窗口，不要再弹出了
                // '游戏名X': true,
            },
            crash: {
                animation: true,
            },
            dice: {
                animation: true,
                fast: true,
            },
            mines: {
                animation: true,
            },
            keno: {
                animation: true,
                fast: false,
            },
            roulette: {
                animation: true,
                fast: false,
            },
            pharaoh: {
                fast: false,
                animation: true,
                auto: { default: false },
            },
            corgiwild: {
                animation: true,
                fast: false,
            },
            blackjack:{
                animation: true,
                fast: false,
            },
        },
        bonusCombats: {
            rightPanelBonusCombatsId: null,
            shareCheckbox: true,
        },
        withDrawWallets: [{name:'test',address:'000addresstest'}],
    }),
    actions: {
        setWithDrawWallets(newVal) {
            this.withDrawWallets = newVal;
        },
    },
    getters: {
        getSettings: (state) => state,
    },
    persist: {
        storage: persistedState.localStorage,
    },
});

export default useSettingsStore;
